import {Component, Input} from '@angular/core';

@Component({
	selector: 'form-page',
	templateUrl: './form-page.component.html'})
export class FormPageWidget {
	@Input() title:string;
	@Input() icon:string;
	@Input() errors:Array<string>;
	@Input() successes:Array<string>;
	@Input() showSave:boolean = true;
	@Input() cancelText:string = 'general.cancel';
	@Input() goBackLink: string;
	@Input() save:()=>{};
}
